import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card} from 'antd';
import CollectionFetch from '@web/ui/containers/CollectionFetch';
import AppsList from './AppsList';
import {LinesContext} from '@web/hooks/context';
import {useLocation} from 'wouter';

AppsCard.propTypes = {
  tabKey: PropTypes.string,
  onSelect: PropTypes.func,
};

function AppsCard(props) {
  const ctx = React.useContext(LinesContext);
  const [, setLocation] = useLocation();
  const [tabKey, setTabKey] = React.useState(props.tabKey || "workflows");

  return <Card
    onTabChange={setTabKey}
    style={{width: 600}}
    className="card-simple card-h-600 card-body-scroll card-no-separator card-no-title"
    activeTabKey={tabKey}
    // tabProps={{centered: true}}
    tabBarExtraContent={{
      right: <Button
        size="normal"
        type="primary"
        onClick={() => setLocation(["/collections", ctx.collectionId, "collections/workflows/create"].join("/"))}
      >New</Button>
    }}
    // extra={}
    tabList={[{
      key: "workflows",
      tab: "Workflows",
    },{
      key: "apps",
      tab: "Apps",
    },{
      key: "app-store",
      tab: "Store",
    }]}
  >
    <CollectionFetch
      collectionId={tabKey}
      component={AppsList}
      onClick={(item) => props.onSelect(item)}
    />
  </Card>
}

export default AppsCard;
